import React, { useState } from 'react';
import {
	TokenGroup,
	SpaceBetween,
	Box,
	Input,
	Button,
} from '@amzn/awsui-components-console';
import { MultiInputHtmlElementProps } from './multiInputHtmlElement.interface';

export default function MultiInputHtmlElement({
	tokens,
	onAdd,
	onRemove,
	dataTestId,
	rightAction,
}: MultiInputHtmlElementProps) {
	const [input, setInput] = useState('');

	return (
		<Box>
			<SpaceBetween size="xs">
				<Input
					onChange={({ detail }) => {
						setInput(detail.value);
					}}
					value={input}
					type="text"
					data-testid={`${dataTestId}-input`}
				/>
				<Box float="right">
					<SpaceBetween direction="horizontal" size="xs">
					<Button
						onClick={() => {
							input && onAdd(input);
							setInput('');
						}}
						data-testid={`${dataTestId}-add-button`}
					>
						Add to List
					</Button>
					{rightAction}
					</SpaceBetween>
				</Box>
			</SpaceBetween>
			<TokenGroup
				items={tokens}
				onDismiss={onRemove}
				data-testid={`${dataTestId}-token-group`}
			/>
		</Box>
	);
}
